import { createSlice } from '@reduxjs/toolkit';

interface UserState {
    expiration: string | null;
    admin: boolean;
    id: number | null;
}

const initialState: UserState = {
    expiration: localStorage.getItem('expiration') ? localStorage.getItem('expiration') : null,
    admin: localStorage.getItem('isAdmin') ? JSON.parse(localStorage.getItem('isAdmin') ?? 'false') : false,
    id: localStorage.getItem('brokerId') ? Number(localStorage.getItem('brokerId')) : null,
};

const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        setUser: (state, action) => {
            console.log('[setUser]', action.payload);
            const { expiration, admin, id } = action.payload;
            state.expiration = expiration;
            state.admin = admin;
            state.id = id;
            localStorage.setItem('brokerId', id.toString());
            localStorage.setItem('isAdmin', (admin === true).toString());
            localStorage.setItem('expiration', expiration.toString());
        },
        setExpiration: (state, action) => {
            // console.log('[setExpiration]', action.payload);
            state.expiration = action.payload;
            localStorage.setItem('expiration', action.payload.toString());
        },
        clearUser: (state) => {
            // console.log('[clearUser]');
            state.expiration = null;
            state.admin = false;
            state.id = null;
            localStorage.removeItem('brokerId');
            localStorage.removeItem('isAdmin');
            localStorage.removeItem('expiration');
        },
        setBrokerId: (state, action) => {
            state.id = action.payload;
            localStorage.setItem('brokerId', action.payload.toString());
        },
    },
});

export const { setUser, clearUser, setBrokerId, setExpiration } = authSlice.actions;
export default authSlice.reducer;